 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime~main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"banner":"banner","cards":"cards","common":"common","accordion":"accordion","caveats":"caveats","content-blocks":"content-blocks","fund-cards":"fund-cards","fund-compare":"fund-compare","fund-press-releases":"fund-press-releases","marketo-form":"marketo-form","cta-banner":"cta-banner","dynamic-cards":"dynamic-cards","image-grid":"image-grid","interactive-content":"interactive-content","link-list":"link-list","tax":"tax","Latest Dividends":"Latest Dividends","literature":"literature","njbest-treasurry-managed-layout":"njbest-treasurry-managed-layout","on-page-search":"on-page-search","profile":"profile","role-selector-cards":"role-selector-cards","fund-attribution":"fund-attribution","product-detail-layout":"product-detail-layout","morningstar-table":"morningstar-table","product-details":"product-details","section-nav":"section-nav","us-index":"us-index","table-with-filters":"table-with-filters","vendor.async.xlsx":"vendor.async.xlsx","article":"article","german-calculator-one-time-investment":"german-calculator-one-time-investment","german-calculator-pension":"german-calculator-pension","german-calculator-savings-plan":"german-calculator-savings-plan","german-calculator-withdrawl-plan":"german-calculator-withdrawl-plan","australia-fund-platforms":"australia-fund-platforms","retirement-lifestyle-tool":"retirement-lifestyle-tool","us-index-allocations":"us-index-allocations","us-index-banner":"us-index-banner","us-index-performance":"us-index-performance","what-happened-last-week":"what-happened-last-week","cpreif-portfolio-tool":"cpreif-portfolio-tool","dynamic-dropdown-tool":"dynamic-dropdown-tool","fixed-income-fine-tuning":"fixed-income-fine-tuning","effective-annual-costs":"effective-annual-costs","munimap":"munimap","news-feeds-tool":"news-feeds-tool","pcstool":"pcstool","popquiz":"popquiz","cpreif-location-map":"cpreif-location-map","njbest-treasury-managed-price-and-performance":"njbest-treasury-managed-price-and-performance","literature-audit":"literature-audit","vendor.async.gaugeJS":"vendor.async.gaugeJS","recession-dashboard":"recession-dashboard","njbest-contribution-calculator":"njbest-contribution-calculator","quotential-questionnaire":"quotential-questionnaire"}[chunkId]||chunkId) + "-es2015." + {"0":"22c5e792d54b02884d5b","banner":"a73bc906a9fed4618157","cards":"90bce6e38977a55e8154","common":"f6c3642c3ba74f35f956","accordion":"31a3fd67260d95067617","caveats":"de7e954b724445b49e44","content-blocks":"376d1fe963853cbf8b99","fund-cards":"b3243a3401c2707c4240","fund-compare":"dea5b7770280cae02d7f","fund-press-releases":"a0d538f6e1f4fc07cbff","marketo-form":"2bd0665dbae5a36b1282","cta-banner":"bbb87e73d70272f2d0bc","dynamic-cards":"ac187d05164303c48582","image-grid":"81e0002cde4ec4dafae0","interactive-content":"92770f23d9e579abcbdb","link-list":"6b905a07b32696375526","tax":"32531cc5da0bb32361dd","Latest Dividends":"ca9f9867493fa6f32e0f","literature":"c80c594b4867a2d8397d","njbest-treasurry-managed-layout":"b940f35021d4b1afabcd","on-page-search":"10adbc3f9fea8e0fca7c","profile":"8d41553fd96e1e57c41b","role-selector-cards":"b96ae787ab13553b5013","fund-attribution":"98e4ef0b26620b2aee99","product-detail-layout":"0e4120e4fd0d8306dc31","morningstar-table":"e1be30457456329b1b93","product-details":"1dcf427aa020b4b7a6b5","section-nav":"8ef138e062f5195fcb27","us-index":"ea916f4244c0a1fba90d","table-with-filters":"441651f0fe6961947578","vendor.async.xlsx":"1c293854145bccbf7452","article":"d2de81097a995fcd793a","german-calculator-one-time-investment":"4350acb108a8a64dcdfc","german-calculator-pension":"b800227305f1e99a2ee2","german-calculator-savings-plan":"58f0d2d85711a540733b","german-calculator-withdrawl-plan":"ef770d85c511d803f5e8","australia-fund-platforms":"0462423b8525df78b68e","retirement-lifestyle-tool":"66bb9f064dc974f9525a","us-index-allocations":"ca22487748f23020559c","us-index-banner":"cc9bc99216dc659e0bf9","us-index-performance":"29de25f3731360b3893a","what-happened-last-week":"61d9149f9ec51a4b8d64","cpreif-portfolio-tool":"2e33fc1d1332da0af0af","dynamic-dropdown-tool":"e3b3f84d069a1c8ff83b","fixed-income-fine-tuning":"dd6471d287ab4d38cb3d","effective-annual-costs":"e493d9007fdb3cc6dd76","munimap":"fca44621700a2916caa1","news-feeds-tool":"177bd838eda86add33cc","pcstool":"97ba4e646fd655beffa2","popquiz":"a37cf47f46ceb8f34b41","cpreif-location-map":"3a3f440d3782e404e15e","njbest-treasury-managed-price-and-performance":"9490cef89d2d21cad3f2","literature-audit":"9273d8f6a5f5a741a7c2","vendor.async.gaugeJS":"ea9e8c90ca4f79ce542e","recession-dashboard":"95353f758adf6abf61da","njbest-contribution-calculator":"07fed003f8a82f622195","quotential-questionnaire":"2bf9735c078b3f9ccb4a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
